export default abstract class BasicType {
    public abstract toString(): string;
}
